import React from 'react';
import { AuthProvider, useAuth } from './helpers/AuthContext';
import mountComponents from './mountComponents';
import Mediapicker from './components/Mediapicker';
import AdminTasks from "./components/AdminTasks";
import ProductsListSection from "./components/Seller/ProductsListSection";
import SellerForum from "./components/Seller/SellerForum";
import SocialsManager from "./components/Seller/SocialsManager";
import Table from "./components/Table";
import Section from "./components/Section";
import Form from "./components/Form";
import ShippingWizard from "./components/Seller/Shipping/ShippingWizard";
import {ConnectedCustomerMessage} from "./components/CustomerMessage";
import DevRoadmapBoard from "./components/Seller/DevRoadmapBoard";
import AdminAIChat from "./components/Admin/AdminAIChat";
import FloatingAdminAIChat from "./components/Admin/FloatingAIChat";
import IntelligentTicketResponseTextarea from "./components/Admin/IntelligentTicketResponseTextarea";
import FriendsManager from "./components/Seller/FriendsManager";
import AweChart from "./components/Seller/AweChart";
import StorefrontAnalytics from "./components/Seller/Analytics/StorefrontAnalytics";
import ChannelAdminsManager from "./components/Seller/Admins/ChannelAdminsManager";
import MultiUploader from "./components/Seller/MultiUploader";
import ProductGalleryMultiUploader from "./components/Seller/Product/ProductGalleryMultiUploader";
import ProductWizard from "./components/Seller/Product/ProductWizard";
import ProductWizardCreateButton from "./components/Seller/Product/ProductWizardCreateButton";
import ProductCompliancePage from "./components/Seller/Product/ProductCompliancePage";
import ProductSubpane from "./components/Seller/Product/ProductSubpane";
import MarketplaceVisibilityBanner from "./components/Seller/MarketplaceVisibilityBanner";
import CouponsManagerSection from "./components/Seller/Coupons/CouponsManagerSection";
import InvoicesManagerSection from "./components/Seller/Invoices/InvoicesManagerSection";
import CustomCssManager from "./components/Seller/CustomCssManager";
import StorefrontManagerSection from "./components/Seller/Storefront/StorefrontManagerSection";
import LinkTreeManagerSection from "./components/Seller/Links/LinkTreeManagerSection";
import HelpArticleLink from "./components/Seller/HelpArticleLink";
import SellerActionCenter from "./components/Seller/SellerActionCenter";
import SellerOnboardingTodos from "./components/Seller/SellerOnboardingTodos";
import BookingManager from "./components/Seller/Booking/BookingManager";
import OrdersManager from './components/Seller/Orders/OrdersManager';
import TaxCenterManager from './components/Seller/Tax/TaxCenterManager';
import SellerReviewsManager from './components/Seller/Reviews/SellerReviewsManager';
import SellerMessages from './components/Seller/Messages/SellerMessages';
import OrdersAttentionWidget from './components/Seller/Orders/OrdersAttentionWidget';
import MediaLibraryDemo from './components/Seller/Media/MediaLibraryDemo';
import MediaCropHarness from './components/Seller/Media/MediaCropHarness';
import MediaLibraryManager from './components/Seller/Media/MediaLibraryManager';
import AffiliatesManagerSection from './components/Seller/Affiliates/AffiliatesManagerSection';
import AffiliateReferralPanel from './components/Seller/Affiliates/AffiliateReferralPanel';
import VerificationCenter from './components/Seller/Verification/VerificationCenter';
import PlanBillingPage from './components/Seller/Billing/PlanBillingPage';
import SellerPlanPaybackHarness from './components/Seller/Billing/SellerPlanPaybackHarness';
import ContentEditor from './components/Seller/Content/ContentEditor';
import ContentEditorDemo from './components/Seller/Content/ContentEditorDemo';
import ContentListManager from './components/Seller/Content/ContentListManager';
import NewslettersManager from './components/Seller/Newsletters/NewslettersManager';
import SellerAudiencePreview from './components/Seller/Audience/SellerAudiencePreview';
import CustomerDirectory from './components/Seller/Customers/CustomerDirectory';
import SellerNavSidebar from './components/Seller/Nav/SellerNavSidebar';
import LabelPrinter from './components/Seller/Labels/LabelPrinter';
import {LabelPrinterModalButton} from './components/Seller/Labels/LabelPrinterModal';
import {
    VerificationCenterLauncher,
} from './components/Seller/Verification/VerificationCenterModal';
import {
    initializeBrowserI18n,
    PlatformI18nProvider,
} from './helpers/i18n';
import I18nProof from './components/I18nProof';

// Example components (replace with your actual components)
function App() {
    return <h1>Hello, React!</h1>;
}
function AnotherComponent({text}) {
    const auth = useAuth();
    return <div>
        <div>Another Component: {text}</div>
        <div>DASHBOARD_URL: {auth.DASHBOARD_URL}</div>
        <div>API_URL: {auth.API_URL}</div>
    </div>;
}

function TestForm() {
    const [values, setValues] = React.useState({
        username: 'hoodoo',
        email: 'email@you.com',
        password: 'asdfs',
        bio: 'test test ',
        profilePicture: null
    });
    return (
        <Section title="Test Form">
            <Form
                values={values}
                onChange={(newValues, name, value) => {
                    setValues(newValues);
                }}
                onSubmit={(formValues) => {
                    console.log('Form submitted:', formValues);
                }}
                fields={[
                    { name: 'username', type: 'text', label: 'Username', placeholder: 'Enter your username', required: true },
                    { name: 'email', type: 'email', label: 'Email', placeholder: 'Enter your email', required: true },
                    { name: 'password', type: 'password', label: 'Password', placeholder: 'Enter your password', required: true },
                    { name: 'bio', type: 'textarea', label: 'Bio', placeholder: 'Tell us about yourself' },
                    { name: 'profilePicture', type: 'file', label: 'Profile Picture', accept: 'image/jpeg,image/png,image/webp' },
                    { name: 'terms', type: 'checkbox', label: 'Terms and conditions', required: true, placeholder: 'I agree to the terms' },
                    { name: 'submit', type: 'submit', label: 'Submit', className: 'btn btn-primary' }
                ]}
            />
        </Section>
    )
}
function TestDraggableTable() {
    const [data, setData] = React.useState([
        { id: 1, name: 'Item 1', value: 10 },
        { id: 2, name: 'Item 2', value: 20 },
        { id: 3, name: 'Item 3', value: 30 }
    ]);

    return <Section title="Test Draggable Table">
        <Table
            data={data}
            columns={[
                { key: 'id', label: 'ID' },
                { key: 'name', label: 'Name' },
                { key: 'value', label: 'Value' }
            ]}
            keyField="id"
            draggable={true}
            onDragEnd={(newData) => {
                console.log('New data after drag:', newData);
                setData(newData);
            }}
        />
    </Section>
}

// Load environment variables from global window object
const ENV = window.__ENV__ || {};

function componentWrapper(Component, props={}, i18n) {
    // wrap components with bootstrappers, context, etc.
    return (
        <PlatformI18nProvider i18n={i18n}>
            <AuthProvider env={ENV}>
                <Component {...props} />
            </AuthProvider>
        </PlatformI18nProvider>
    );
}

/**
 * Mount-point naming convention:
 *   `r-*`  — seller dashboard / admin components (AuthProvider, token auth)
 *   `s-*`  — shopper-facing components on storefronts, the marketplace, and
 *            checkout (ShopperProvider, cookie auth, shopper API URLs)
 *
 * This seller entrypoint owns `r-*`; shopper.jsx owns `s-*`. Both entrypoints
 * use mountComponents so data-props parsing and multi-mount behavior stay shared.
 */
const injectionPoints = {
    '#root': App,
    '#another-root': AnotherComponent,
    '.r-i18n-proof': I18nProof,
    '.r-mediapicker': Mediapicker,
    '#r-admin-todos': AdminTasks,
    '.r-admin-ai-chat': AdminAIChat,
    '#r-products-list': ProductsListSection,
    '#r-seller-forum': SellerForum,
    '#r-socials-manager': SocialsManager,
    '#test-draggable-table': TestDraggableTable,
    '#test-form': TestForm,
    '#r-shipping-calculator': ShippingWizard,
    '.r-customer-message': ConnectedCustomerMessage,
    '.r-dev-roadmap-board': DevRoadmapBoard,
    '.r-help-ticket-intelligent-textarea': IntelligentTicketResponseTextarea,
    '#r-admin-floating-ai-chat': FloatingAdminAIChat,
    '.r-manage-friends': FriendsManager,
    '#r-coupons-manager': CouponsManagerSection,
    '#r-invoices-manager': InvoicesManagerSection,
    '#r-storefront-manager': StorefrontManagerSection,
    '#r-link-tree-manager': LinkTreeManagerSection,
    '#r-custom-css-manager': CustomCssManager,
    '#r-awe-chart': AweChart,
    '#r-storefront-analytics': StorefrontAnalytics,
    '.r-multi-uploader': MultiUploader,
    '#r-product-gallery-multi-uploader': ProductGalleryMultiUploader,
    '#r-product-wizard': ProductWizard,
    '#r-product-compliance': ProductCompliancePage,
    '#r-product-subpane': ProductSubpane,
    '#r-marketplace-visibility-banner': MarketplaceVisibilityBanner,
    '#r-channel-admins-manager': ChannelAdminsManager,
    '.r-create-product-btn': ProductWizardCreateButton,
    '.r-help-article-link': HelpArticleLink,
    '.r-seller-action-center': SellerActionCenter,
    '#r-booking-manager': BookingManager,
    '.r-seller-onboarding-todos': SellerOnboardingTodos,
    '#r-orders-manager': OrdersManager,
    '#r-tax-center': TaxCenterManager,
    '#r-seller-reviews': SellerReviewsManager,
    '#r-seller-messages': SellerMessages,
    '.r-orders-attention-widget': OrdersAttentionWidget,
    '#r-media-library-demo': MediaLibraryDemo,
    '#r-media-crop-harness': MediaCropHarness,
    '#r-media-library': MediaLibraryManager,
    '#r-verification-center': VerificationCenter,
    '.r-verification-center-launcher': VerificationCenterLauncher,
    '#r-affiliates-manager': AffiliatesManagerSection,
    '#r-affiliate-referral': AffiliateReferralPanel,
    '#r-plan-billing': PlanBillingPage,
    // bktestpage only (PLAN-SELLER-PLAN-PAYBACK-MILESTONE Phase 4a); customer mounts arrive in Phase 6.
    '#r-seller-plan-payback-harness': SellerPlanPaybackHarness,
    // bktestpage only (PLAN-SHOPPER-SHOP-DISCOVERY Phase 4a); the customer mount arrives in Phase 6.
    '#r-seller-audience-preview': SellerAudiencePreview,
    '#r-content-editor': ContentEditor,
    '#r-content-editor-demo': ContentEditorDemo,
    '#r-content-list': ContentListManager,
    '#r-newsletters': NewslettersManager,
    '#r-newsletter-allotments': NewslettersManager,
    '#r-customer-directory': CustomerDirectory,
    '.r-seller-nav-sidebar': SellerNavSidebar,
    '#r-label-printer': LabelPrinter,
    // bktestpage only (PLAN-REACT-SELLER-LABEL-PRINTER Phase 2); OrdersManager opens the modal in Phase 5.
    '#r-label-printer-modal-button': LabelPrinterModalButton,
    // Add more mappings as needed
};

initializeBrowserI18n().then(i18n => {
    try {
        mountComponents(injectionPoints, (Component, props) => (
            componentWrapper(Component, props, i18n)
        ));
    } catch (error) {
        console.error('Platform React mounts failed', {
            event: 'platform_i18n_react_mount_failure',
            bundle: 'seller-admin',
            locale: i18n.resolvedLanguage || i18n.language,
            reason: error?.name || 'mount_failed',
        });
    }
});
